import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, loadAnalytics } from "@/lib/analytics";
import { isSnapshot } from "@/lib/seo";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c === "granted") loadAnalytics();
    else if (!c) setVisible(true);
    const reopen = () => setVisible(true);
    window.addEventListener("fedari:cookie-settings", reopen);
    return () => window.removeEventListener("fedari:cookie-settings", reopen);
  }, []);

  useEffect(() => {
    document.body.style.paddingBottom = visible ? "118px" : "";
    return () => { document.body.style.paddingBottom = ""; };
  }, [visible]);

  // During the prerender pass, render nothing so the static HTML matches the
  // client's initial (pre-effect) render and avoids a hydration mismatch.
  if (isSnapshot() || !visible) return null;

  const decide = (value) => { setConsent(value); setVisible(false); };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      data-testid="cookie-consent"
      data-consent-banner
      className="fixed bottom-[76px] lg:bottom-4 lg:left-4 lg:right-auto inset-x-0 z-[120] px-3 pb-1 lg:p-0 lg:max-w-[400px]"
    >
      <div className="bg-navy text-white rounded-xl shadow-xl border border-[#232A34] px-4 py-3 flex flex-col gap-2.5">
        <p className="text-[0.78rem] text-[#cdd6e4] leading-snug">
          We use essential cookies and, with your consent, analytics. See our{" "}
          <Link to="/privacy-policy" className="underline hover:text-white">Privacy Policy</Link>.
        </p>
        <div className="flex gap-2">
          <button
            data-testid="cookie-decline"
            onClick={() => decide("denied")}
            className="flex-1 px-3 py-2 rounded-lg border border-[#39424f] text-white text-[0.82rem] font-semibold hover:border-white/60 transition-colors min-h-[40px]"
          >
            Decline
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => decide("granted")}
            className="flex-1 px-3 py-2 rounded-lg bg-blue text-white text-[0.82rem] font-semibold hover:bg-blue-600 transition-colors min-h-[40px]"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
